import { useNavigate } from "react-router-dom";
import { topics } from "@/mocks/topics";
import SectionTitle from "@/components/feature/SectionTitle";

export default function TopicsSection() {
  const navigate = useNavigate();

  return (
    <section className="w-full py-14 md:py-16">
      <div className="container-x">
        <SectionTitle
          kicker="题材专题"
          title="读懂古风漫画，不止于追更"
          desc="题材观察、漫画漫谈、读者故事……在这里更深入地理解古风国漫的魅力。"
          action={
            <button
              onClick={() => navigate("/topics")}
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-600 cursor-pointer"
            >
              全部专题<i className="ri-arrow-right-line text-xs"></i>
            </button>
          }
        />
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {topics.slice(0, 2).map((topic) => (
            <article
              key={topic.id}
              onClick={() => navigate(`/topic/${topic.id}`)}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-shadow hover:shadow-md sm:flex-row"
            >
              <div className="h-44 w-full shrink-0 overflow-hidden sm:h-auto sm:w-56 md:w-64">
                <img
                  src={topic.image}
                  alt={topic.title}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="tag-chip w-fit">{topic.category}</span>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
                  {topic.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{topic.summary}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-calendar-line"></i>{topic.date}</span>
                  <span className="flex items-center gap-1"><i className="ri-time-line"></i>{topic.readTime}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}